import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { LoadingBackDrop } from "../../../components/loader";
import { theme } from "../../../helpers/theme";
import { GoBackButton } from "../../../components/GoBackButton";
import { pricelistGetAllById } from "../../../services/pricelists/pricelist-get-by-id";
import { PriceList } from "../../../services/pricelists/pricelist-get-by-id/types";
import PricelistForm from "./PricelistForm";

export const OperatorWarehousesPricelistEdit = () => {
  const { id } = useParams();

  const [pricelist, setPricelist] = useState<PriceList[]>([]);

  // useEffect(() => {
  //   console.log("pricelist", pricelist);
  // }, [pricelist]);

  const bodyPricelist = {
    paginacja: null,
    filtr: {
      cennik_id: id,
    },
  };

  const GetPricelistGetAllById = useQuery(
    ["pricelistGetAllById"],
    () => pricelistGetAllById(bodyPricelist),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setPricelist(data.data.payload.cenniki);
      },
    }
  );

  const bodyPricelistDates = {
    paginacja: null,
    filtr: {
      cennik_id: id,
    },
  }; 

  const GetPricelistTypeDates= useQuery(
    ["pricelistGetAllById"],
    () => pricelistGetAllById(bodyPricelistDates),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setPricelist(data.data.payload.cenniki);
      },
    }
  );


  if (GetPricelistGetAllById.isLoading || GetPricelistGetAllById.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
    <ButtonWrapper>
    <GoBackButton description={"Powrót"} goToUrl={-1} />
    </ButtonWrapper>
    <FormWrapper>
        <PricelistForm {...pricelist}/>
    </FormWrapper>
    </>
  );
};

export default OperatorWarehousesPricelistEdit;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  // padding: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
    width: 70%;
    margin-top: 0px;
  }

  .tabPanel {
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  z-index: 10000;
  // display: flex;
  // justify-content: flex-start;


  @media (${theme.device.laptop}) {
    margin-left: 320px
  }
`;